export default {"src":"/_next/static/media/business.591606c3.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};